import React from 'react';
import PropTypes from 'prop-types';
import { getCronModel } from '../get-cron-model';
import { DailyExtra } from './daily-extra';
import { WeeklyExtra } from './weekly-extra';
import { MonthlyExtra } from './monthly-extra';

export function Extra({
  classNamePrefix,
  cronFormatter,
  cron,
  onChange,
  ariaLabelledby,
}) {
  const {
    NONE, DAILY, WEEKLY, MONTHLY,
  } = cronFormatter.getCronFrequenciesEnum();
  const {
    frequency,
    dayOfMonth,
    dayOfWeek,
    hour,
  } = getCronModel(cronFormatter, cron);

  switch (frequency) {
    case DAILY:
      return (
        <DailyExtra
          classNamePrefix={classNamePrefix}
          cronFormatter={cronFormatter}
          hour={hour}
          onChange={onChange}
          ariaLabelledby={ariaLabelledby}
        />
      );
    case WEEKLY:
      return (
        <WeeklyExtra
          classNamePrefix={classNamePrefix}
          cronFormatter={cronFormatter}
          dayOfWeek={dayOfWeek}
          hour={hour}
          onChange={onChange}
          ariaLabelledby={ariaLabelledby}
        />
      );
    case MONTHLY:
      return (
        <MonthlyExtra
          classNamePrefix={classNamePrefix}
          cronFormatter={cronFormatter}
          dayOfMonth={dayOfMonth}
          hour={hour}
          onChange={onChange}
          ariaLabelledby={ariaLabelledby}
        />
      );
    case NONE:
    default:
      return null;
  }
}

Extra.propTypes = {
  classNamePrefix: PropTypes.string.isRequired,
  cronFormatter: PropTypes.shape({
    toCronString: PropTypes.func,
  }).isRequired,
  cron: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  ariaLabelledby: PropTypes.string,
};

Extra.defaultProps = {
  cron: undefined,
  ariaLabelledby: '',
};
